// extracted by mini-css-extract-plugin
export default {"container":"logs_container__EgDFG","linksWrapper":"logs_linksWrapper__OrsoT","linkWrapper":"logs_linkWrapper__2ISIO"};